module.exports = "<div>\r\n    <size-image-animate v-if=\"isShowAnimate\" :images=\"images\" :bg-color=\"bgColor\" :bg-color-down=\"bgColorDown\"></size-image-animate>\r\n    <size-image-single v-else :image=\"image\" :bg-color=\"bgColor\" :bg-color-down=\"bgColorDown\"></size-image-single>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/component/size-image.html
// module id = 241
// module chunks = 0